import { getStops } from "../../../app/api/getStops";
import { BaseAction } from "../../../core/actions/BaseAction";
import { getRuntimeConfig } from "../../../Lib/Config/RuntimeConfig";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IApiResponse, IStop, StationsListType } from "../../../Orchestrator/Types/Index";
import { getDepartureFromListByStationAction } from "./GetDepartureFromListByStationAction";
import { transformStops } from "./GetStopsAction";
class GetDepartureFromListAction extends BaseAction<void, void> {
    override async run(): Promise<void> {
        try {
            const config = await getRuntimeConfig();
            const response: IApiResponse<{ stops: IStop[] }> = await getStops(false);
            if (response.status === "ok" && response.answer) {
                const stops = response.answer.stops;
                if (stops.length > 0) {
                    let StationLists = transformStops(stops, config.NEXT_PUBLIC_STOP_EXTERNAL_CODE)
                    updateRecoilState<StationsListType>("stopsResponseAtom", StationLists);
                    const firstStation = StationLists[0];

                    getDepartureFromListByStationAction.setParams({
                        fromStationCode: firstStation.id,
                        StationLists: StationLists
                    });
                    await getDepartureFromListByStationAction.execute();
                }
            } else {
                console.warn("Failed to fetch stops.");
            }
        } catch (error: any) {

        } finally {

        }
    }
}

export const getDepartureFromListAction = new GetDepartureFromListAction()